/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
} from "@material-ui/core";

import { skaleWhite } from "config/UpduoColors";

interface MemberTableBaseProps {
  headers: (JSX.Element | JSX.Element[])[];
  body: JSX.Element[] | null;
}

export default function MemberTableBase({
  headers,
  body,
}: MemberTableBaseProps) {
  return (
    <View
      style={{
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        backgroundColor: skaleWhite,
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
      }}
    >
      <View style={{ width: "96%" }}>
        <TableContainer>
          <Table stickyHeader aria-label={"sticky table"}>
            <TableHead>
              <TableRow>{headers}</TableRow>
            </TableHead>
            <TableBody>{body}</TableBody>
          </Table>
        </TableContainer>
      </View>
    </View>
  );
}
